import { SimMetricsBruto } from "@interfaces";

export const SimMetricsBrutoMockData: SimMetricsBruto[] = [
  { year: 2026, month: 1, "sum(`value`)": 124.52 },
  { year: 2026, month: 3, "sum(`value`)": 145.67 },
  { year: 2026, month: 2, "sum(`value`)": 132.84 },
  { year: 2026, month: 4, "sum(`value`)": 138.91 },
  { year: 2026, month: 5, "sum(`value`)": 152.43 },
  { year: 2026, month: 6, "sum(`value`)": 161.29 },
  { year: 2026, month: 7, "sum(`value`)": 148.76 },
  { year: 2026, month: 8, "sum(`value`)": 172.35 },
  { year: 2026, month: 9, "sum(`value`)": 180.44 },
  { year: 2026, month: 10, "sum(`value`)": 167.91 },
  { year: 2026, month: 11, "sum(`value`)": 189.17 },
  { year: 2026, month: 12, "sum(`value`)": 201.55 },
];

export const SimMetricsGroupedMockData = {
  results: [
    { year: 2026, month: 1, metric_group: 'subscriptions', "sum(`value`)": 875.42 },
    { year: 2026, month: 1, metric_group: 'calls',         "sum(`value`)": 39.82 },
    { year: 2026, month: 1, metric_group: 'data',          "sum(`value`)": 71.35 },
    { year: 2026, month: 1, metric_group: 'sms',           "sum(`value`)": 8.20 },
    { year: 2026, month: 1, metric_group: 'mpay',          "sum(`value`)": 42.15 },

    { year: 2026, month: 2, metric_group: 'subscriptions', "sum(`value`)": 878.93 },
    { year: 2026, month: 2, metric_group: 'calls',         "sum(`value`)": 41.24 },
    { year: 2026, month: 2, metric_group: 'data',          "sum(`value`)": 74.96 },
    { year: 2026, month: 2, metric_group: 'sms',           "sum(`value`)": 7.90 },
    { year: 2026, month: 2, metric_group: 'mpay',          "sum(`value`)": 41.80 },

    { year: 2026, month: 3, metric_group: 'subscriptions', "sum(`value`)": 882.45 },
    { year: 2026, month: 3, metric_group: 'calls',         "sum(`value`)": 40.56 },
    { year: 2026, month: 3, metric_group: 'data',          "sum(`value`)": 78.44 },
    { year: 2026, month: 3, metric_group: 'sms',           "sum(`value`)": 7.50 },
    { year: 2026, month: 3, metric_group: 'mpay',          "sum(`value`)": 43.25 },

    { year: 2026, month: 4, metric_group: 'subscriptions', "sum(`value`)": 886.87 },
    { year: 2026, month: 4, metric_group: 'calls',         "sum(`value`)": 42.01 },
    { year: 2026, month: 4, metric_group: 'data',          "sum(`value`)": 80.62 },
    { year: 2026, month: 4, metric_group: 'sms',           "sum(`value`)": 7.10 },
    { year: 2026, month: 4, metric_group: 'mpay',          "sum(`value`)": 43.95 },

    { year: 2026, month: 5, metric_group: 'subscriptions', "sum(`value`)": 889.32 },
    { year: 2026, month: 5, metric_group: 'calls',         "sum(`value`)": 44.25 },
    { year: 2026, month: 5, metric_group: 'data',          "sum(`value`)": 82.75 },
    { year: 2026, month: 5, metric_group: 'sms',           "sum(`value`)": 6.90 },
    { year: 2026, month: 5, metric_group: 'mpay',          "sum(`value`)": 44.30 },

    { year: 2026, month: 6, metric_group: 'subscriptions', "sum(`value`)": 890.58 },
    { year: 2026, month: 6, metric_group: 'calls',         "sum(`value`)": 43.91 },
    { year: 2026, month: 6, metric_group: 'data',          "sum(`value`)": 81.84 },
    { year: 2026, month: 6, metric_group: 'sms',           "sum(`value`)": 6.75 },
    { year: 2026, month: 6, metric_group: 'mpay',          "sum(`value`)": 44.50 },

    // Jouw bestaande waarden
    { year: 2026, month: 7, metric_group: 'subscriptions', "sum(`value`)": 891.6369999999991 },
    { year: 2026, month: 7, metric_group: 'calls',         "sum(`value`)": 43.6367 },
    { year: 2026, month: 7, metric_group: 'data',          "sum(`value`)": 83.06800000000001 },
    { year: 2026, month: 7, metric_group: 'sms',           "sum(`value`)": 6.6 },
    { year: 2026, month: 7, metric_group: 'mpay',          "sum(`value`)": 44.91 },

    { year: 2026, month: 8, metric_group: 'subscriptions', "sum(`value`)": 894.10 },
    { year: 2026, month: 8, metric_group: 'calls',         "sum(`value`)": 45.38 },
    { year: 2026, month: 8, metric_group: 'data',          "sum(`value`)": 86.72 },
    { year: 2026, month: 8, metric_group: 'sms',           "sum(`value`)": 6.40 },
    { year: 2026, month: 8, metric_group: 'mpay',          "sum(`value`)": 45.61 },

    { year: 2026, month: 9, metric_group: 'subscriptions', "sum(`value`)": 897.25 },
    { year: 2026, month: 9, metric_group: 'calls',         "sum(`value`)": 46.91 },
    { year: 2026, month: 9, metric_group: 'data',          "sum(`value`)": 89.35 },
    { year: 2026, month: 9, metric_group: 'sms',           "sum(`value`)": 6.25 },
    { year: 2026, month: 9, metric_group: 'mpay',          "sum(`value`)": 46.85 },

    { year: 2026, month: 10, metric_group: 'subscriptions', "sum(`value`)": 899.84 },
    { year: 2026, month: 10, metric_group: 'calls',         "sum(`value`)": 48.33 },
    { year: 2026, month: 10, metric_group: 'data',          "sum(`value`)": 92.14 },
    { year: 2026, month: 10, metric_group: 'sms',           "sum(`value`)": 6.10 },
    { year: 2026, month: 10, metric_group: 'mpay',          "sum(`value`)": 48.32 },

    { year: 2026, month: 11, metric_group: 'subscriptions', "sum(`value`)": 902.51 },
    { year: 2026, month: 11, metric_group: 'calls',         "sum(`value`)": 49.85 },
    { year: 2026, month: 11, metric_group: 'data',          "sum(`value`)": 94.86 },
    { year: 2026, month: 11, metric_group: 'sms',           "sum(`value`)": 5.95 },
    { year: 2026, month: 11, metric_group: 'mpay',          "sum(`value`)": 49.77 },

    { year: 2026, month: 12, metric_group: 'subscriptions', "sum(`value`)": 905.73 },
    { year: 2026, month: 12, metric_group: 'calls',         "sum(`value`)": 51.62 },
    { year: 2026, month: 12, metric_group: 'data',          "sum(`value`)": 97.43 },
    { year: 2026, month: 12, metric_group: 'sms',           "sum(`value`)": 5.80 },
    { year: 2026, month: 12, metric_group: 'mpay',          "sum(`value`)": 51.24 },
  ]
};

export const SimMetricsMockTotal = SimMetricsBrutoMockData.reduce(
  (sum, item) => sum + item["sum(`value`)"],
  0
);